export const PROGRESS_BANNER_IMAGES = {
    DECORATION_LEFT: '/foodslaboEf/img/ProgressBanner/decoration-left.png',
    DECORATION_RIGHT: '/foodslaboEf/img/ProgressBanner/decoration-right.png',
    LOGO: '/foodslaboEf/img/ProgressBanner/foodslabo-logo.png',
} as const

export const JOB_SEEKER_PROGRESS_DOT_IMAGES = {
    PENDING_DOT_1: '/foodslaboEf/img/ProgressBanner/ab-test/pending-dot-1.svg',
    PENDING_DOT_2: '/foodslaboEf/img/ProgressBanner/ab-test/pending-dot-2.svg',
    PENDING_DOT_3: '/foodslaboEf/img/ProgressBanner/ab-test/pending-dot-3.svg',
    ACTIVE_DOT_1: '/foodslaboEf/img/ProgressBanner/ab-test/active-dot-1.svg',
    ACTIVE_DOT_2: '/foodslaboEf/img/ProgressBanner/ab-test/active-dot-2.svg',
    ACTIVE_DOT_3: '/foodslaboEf/img/ProgressBanner/ab-test/active-dot-3.svg',
    COMPLETED_DOT: '/foodslaboEf/img/ProgressBanner/ab-test/completed-dot.svg',
} as const
